







import {Component, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {UserProfile} from '@/store/modules/views/userProfile/states'
import _ from 'lodash'

@Component
export default class Index extends Vue {
  @Action('components/changeApp')
  private changeApp!: (app: string) => void

  @Action('components/goToPerformanceTrackingApp')
  private goToPerformanceTrackingApp!: () => void

  @Getter('userprofile/getProfile')
  private profile!: UserProfile
}
